module.exports = __webpack_public_path__ + "static/media/plan-507+508-mobile-en.04bda38d.png";